import React, { useEffect } from "react";
import PropTypes from "prop-types";

import ConfirmModal from "components/ConfirmModal";
import DragDropCtx from "components/DragDropCtx";
import DraggableList from "components/DragDropCtx/DraggableList";

import ElementModal from "./ElementModal";
import Placeholder from "./Placeholder";
import Header from "./Header";
import Block from "./Block"

import { StyledCard } from "ui/StyledComponents/StyledCard";

import { usePageElementEditor } from "utils/pageElements/hooks";

const LinksEditor = ({ links, passes, onSave }) => {

  const orgHasCalendar = links.find((link) => link.element_type === "calendar");
  
  const {
    pageElements,
    setPageElements,
    pageElement,
    setPageElement,
    deletingPageElement,
    setDeletingPageElement,
    elementModal,
    setElementModal,

    handleDelete,
    handleDragEnd,
    handleUpdate,
    handleCreate,
    handleModalClose,
    createElementState,
  } = usePageElementEditor(
    links,
    onSave,
    Block,
  );

  useEffect(() => {
    setPageElements(createElementState(links));
  }, [links]);

  return (
    <>
      <StyledCard>
        <Header onClick={() => setElementModal(true)} />

        {pageElements?.length > 0 ? (
          <DragDropCtx handleDragEnd={handleDragEnd}>
            <DraggableList data={pageElements} droppableId="pageElements" />
          </DragDropCtx>
        ) : (
          <Placeholder onClick={() => setElementModal(true)} />
        )}
      </StyledCard>
      
      {elementModal && (
        <ElementModal
          open={elementModal}
          onClose={handleModalClose}
          onSubmit={pageElement?.id ? handleUpdate : handleCreate}
          pageElement={pageElement}
          onPageElementChange={setPageElement}
          passes={passes}
          orgHasCalendar={orgHasCalendar}
        />
      )}

      <ConfirmModal
        title={deletingPageElement && "Delete Link Block?"}
        open={deletingPageElement}
        onConfirm={handleDelete}
        setOpen={setDeletingPageElement}
      >
        Are you sure you want to delete this link block?
      </ConfirmModal>
    </>
  );
};

LinksEditor.propTypes = {
  links: PropTypes.array.isRequired,
  passes: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default LinksEditor;
